export enum GameEventName {
    LOCAL_NOTIFICATION_SENT = 'LocalNotificationSent',
    PRELOAD_COMPLETE = 'PreloadComplete',
}
